import { memo, useCallback } from "react"
import { useDispatch } from "react-redux"

import { setSnippetBookmarkColor } from "rtk-slice"

import {
  Dialog,
  DialogTitle,
  Divider,
  ListItemButton,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material"

import ColorBox from "color-box"
import { ResetColors } from "ui-icons"

const SnippetBookmarkColorDialog = ({
  openSnippetBookmarkColorDialog,
  id,
  bookmarkColor,
  handleCloseSnippetBookmarkColorDialog,
}) => {
  const dispatch = useDispatch()

  const handleSnippetBookmarkColor = useCallback(
    (value) => {
      dispatch(setSnippetBookmarkColor({ id, bookmarkColor: value }))
    },
    [dispatch, id]
  )

  return (
    <Dialog
      onClose={handleCloseSnippetBookmarkColorDialog}
      open={openSnippetBookmarkColorDialog}
      keepMounted={false}
      maxWidth="sm"
      sx={{
        "& .MuiPaper-root": {
          bgcolor: `background.paper !important`,
          backgroundImage: "none",
        },
      }}
    >
      <DialogTitle
        variant="h6"
        fontWeight="bold"
        bgcolor="background.default"
      >
        Bookmarks Snippets Colors
      </DialogTitle>
      <Divider />
      <Typography variant="body2" sx={{ px: "2em", py: "1em" }}>
        Categorize snippets by bookmarks colors, choose a color to
        bookmark the current snippet:
      </Typography>

      <ColorBox
        handler={handleSnippetBookmarkColor}
        bookmarkColor={bookmarkColor}
      />

      <Divider variant="fullWidth" />
      <Stack direction="row" p="1em 2em 2em" spacing={2}>
        <ListItemButton
          onClick={() => {
            handleSnippetBookmarkColor("")
          }}
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <ResetColors />
          Remove Bookmark
        </ListItemButton>
        <ListItemButton
          title="Close"
          onClick={handleCloseSnippetBookmarkColorDialog}
          sx={{ textAlign: "center" }}
        >
          <ListItemText primary="Close" />
        </ListItemButton>
      </Stack>
    </Dialog>
  )
}
export default memo(SnippetBookmarkColorDialog)
